<div class="content">

  <kendo-formfield [showErrors]="'always'">
    <kendo-label>Select user to impersonate</kendo-label>
    <app-user-searchable-dropdown
      [(ngModel)]="selectedUser"
      [excludeIds]="excludedIds"
    >

    </app-user-searchable-dropdown>
  </kendo-formfield>
  <kendo-formfield [showErrors]="'always'">
    <kendo-label>Reason for impersonation</kendo-label>
    <kendo-textarea #res resizable="auto" [(ngModel)]="reason">
    </kendo-textarea>
    <kendo-formerror *ngIf="this.reason===''">Please provide reason for impersonation. Reason is mandatory.</kendo-formerror>
  </kendo-formfield>
  <kendo-formerror>{{this.error}}</kendo-formerror>
  <div class="actions">
    <button
      kendoButton
      (click)="close()"
    >
      Cancel
    </button>
    <button
      kendoButton
      [disabled]="!this.selectedUser || !!this.error || this.reason===''"
      [themeColor]="'primary'"
      (click)="onFinish()"
    >
      Impersonate
    </button>
  </div>
</div>
